export enum PrimaryCode {
  ORDER = 'Encomenda',
  POINTS = 'Pontos',
  EUROS = 'EUROS',
  MESSAGE = 'Mensagem',
  PAYMENTS = 'Pagamentos',
  PURCHASE = 'PURCHASE',
  DISCOUNT = 'DISCOUNT',
  APPOINTMENT = 'Appointment',
  TRANSFER = 'Transferencia',
  PAYMENT_PENDING = 'PAYMENT_PENDING'
}

export enum TransactionCode {
  ADD_POINTS = 'Pontos atribuidos',
  ORDER = 'Encomenda',
  PURCHASE = 'PURCHASE',
  /**
   * Consolidated debit written by the transactions archiving worker. It keeps
   * `primaryCode` ORDER/DISCOUNT only so the balance recomputation works, and
   * it must never be used for invoices, billing, purchases, order listings or
   * order counters. It only stores consolidation values.
   */
  CONSOLIDATION = 'Consolidação',
}

export enum OrderStatus {
  PLACED = 'PLACED', // Placed
  CANCELED = 'CANCELED', // Canceled
  ORDERED = 'ORDERED', // Ordered from Supplier
  ALL_ORDERED = 'ALL_ORDERED', // Ordered from Supplier (total)
  PARTIAL_ORDERED = 'PARTIAL_ORDERED', // Ordered from Supplier (partial)
  COMMISSIONED = 'COMMISSIONED', // <- deprecated ?
  INVOICED = 'INVOICED', // Shipped
  PARTIAL_INVOICED = 'PARTIAL_INVOICED', // Shipped (partial)
  PAYMENT_PENDING = 'PAYMENT_PENDING', // Shipped (total)
  READY = 'READY', // Ready
  DELIVERED = 'DELIVERED', // Delivered
  PROCESSING = 'PROCESSING',
  SENT = 'SENT',
}

export enum MessageStatus {
  PENDING = 'Pendente',
  SOLVED = 'Resolvido',
}

export enum ScheduleStatus {
  OPEN = 'OPEN',
  SCHEDULED = 'SCHEDULED',
  ABSENT = 'ABSENT',
  REQUIRED = 'REQUIRED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  PROFESSIONAL_ABSENT = 'PROFESSIONAL_ABSENT'
}
